import React, { useContext } from "react"
import { ContactUsContext } from "./Layout"
import Dialog from "rc-dialog"
import "rc-dialog/dist/rc-dialog.css"

import ContactForm from "./ContactForm"

const ContactModal = ({ visible, toggleVisibility }) => {
  return (
    <Dialog title={"Contact Us"} onClose={toggleVisibility} visible={visible}>
      <ContactForm from="Contact Modal" />
    </Dialog>
  )
}

export const ContactUsButton = ({ text, className }) => {
  const { toggleModalVisibility } = useContext(ContactUsContext)
  const ClassName = `button-component ${className ? className : ``}`
  return (
    <button onClick={toggleModalVisibility} className={ClassName}>
      <span>{text}</span>
    </button>
  )
}
export default ContactModal
